module.exports = __webpack_public_path__ + "img/lock.1bf0a404.svg";